import styled from 'styled-components'

interface Props {
    selectedPosition: number
}

export const SpeedAdjustmentActionButtons = styled.div<Props>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > button {
        font-size: 16px;
        color: ${p => p.theme.popupForegroundColor};
    }

    & > button:nth-child(${p => p.selectedPosition}) {
        color: ${p => p.theme.popupActiveForegroundColor};
    }

    & > button:not(& > button:first-child) {
        margin-left: 16px;
    }
`
